export default "__VITE_ASSET__15181b4b__"